module.exports = __webpack_public_path__ + "static/media/popup_mobile-tablet.d940685c.jpg";